import React from "react";
import CreateAccountForm from "src/customer/create_account_form";
import { createAccount } from "src/customer/create_account";
import { usePhoneVerifiedSubmission } from "src/customer/use_phone_verified_submission";
import VerificationCodeForm from "src/customer/verification_code_form";

const SignUpPage = ({
  afterSignUpCallback,
  hasStickyHeader,
}: {
  afterSignUpCallback: () => void;
  hasStickyHeader?: boolean;
}) => {
  const { details, verification } = usePhoneVerifiedSubmission({ submit: createAccount, onSuccess: afterSignUpCallback });

  return (
    <>
      <CreateAccountForm
        {...details}
        hasStickyHeader={hasStickyHeader}
      />

      {verification && <VerificationCodeForm verification={verification} isModal={true} />}
    </>
  );
}

export default SignUpPage;
